define(function(require){
	'use strict';

	var Marionette = require('marionette');

	return Backbone.Model.extend({});
});